module.exports = __webpack_public_path__ + "img/c04_unitcataphract_Normal_ua.3d39abe4.webp";